"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMON_COLLECTIONS = exports.PUBLIC_COLLECTIONS = exports.PREMIUM_COLLECTIONS = exports.UsageStatsSubCollectionName = exports.UserSubCollectionName = exports.StorageCollectionName = exports.CollectionName = void 0;
var CollectionName;
(function (CollectionName) {
    CollectionName["ANALYSES"] = "analyses";
    CollectionName["ARTICLES"] = "articles";
    CollectionName["BANNER_NOTIFICATIONS"] = "bannerNotifications";
    CollectionName["CDC_LETTER"] = "cdcLetter";
    CollectionName["CITATIONS"] = "citations";
    CollectionName["CODE_ARTICLES"] = "codeArticles";
    CollectionName["DECISIONS"] = "decisions";
    CollectionName["DELETED_CODE_ARTICLES"] = "deletedCodeArticles";
    CollectionName["DELETED_DECISIONS"] = "deletedDecisions";
    CollectionName["DECISION_REQUESTS"] = "decisionRequests";
    CollectionName["DELETED_USERS"] = "deletedUsers";
    CollectionName["DOCUMENTS_COUNTER"] = "documentsCounter";
    CollectionName["DYNAMIC_FLAGS"] = "dynamicFlags";
    CollectionName["EMAIL_RECIPIENTS"] = "emailRecipients";
    CollectionName["FIVE_INFOS"] = "fiveInfos";
    CollectionName["GLOSSARY_TERMS"] = "glossaryTerms";
    CollectionName["KEYWORD_NODES"] = "keywordNodes";
    CollectionName["LATEXT_TEMPLATES"] = "laTeXTemplates";
    CollectionName["LAW_TEXTS"] = "laws";
    CollectionName["MIGRATIONS"] = "migrations";
    CollectionName["PING"] = "ping";
    CollectionName["PUBLICATION_SHEETS"] = "publicationSheets";
    CollectionName["PUBLIC_ACCESS"] = "publicAccess";
    CollectionName["SCHEMAS"] = "schemas";
    CollectionName["SITEMAP"] = "sitemap";
    CollectionName["STATISTICS"] = "statistics";
    CollectionName["STATISTIC_ENTRIES"] = "statisticEntries";
    CollectionName["TREES"] = "trees";
    CollectionName["TREE_NODES"] = "treeNodes";
    CollectionName["USAGE_STATS"] = "usageStats";
    CollectionName["USERS"] = "users";
    CollectionName["USER_PRIVILEGES"] = "userPrivileges";
    CollectionName["VOGEL_ACADEMY"] = "vogelAcademy";
})(CollectionName || (exports.CollectionName = CollectionName = {}));
var StorageCollectionName;
(function (StorageCollectionName) {
    StorageCollectionName["CDC_LETTER_PDFS"] = "cdcLetterPdfs";
    StorageCollectionName["DECISIONS_FULL_TEXT"] = "decisionsFullText";
    StorageCollectionName["LAWS_FULL_TEXT"] = "lawsFullText";
})(StorageCollectionName || (exports.StorageCollectionName = StorageCollectionName = {}));
var UserSubCollectionName;
(function (UserSubCollectionName) {
    UserSubCollectionName["AI_SEARCHES"] = "aiSearches";
    UserSubCollectionName["REVISION"] = "revisions";
    UserSubCollectionName["SAVED_SEARCHES"] = "savedSearches";
})(UserSubCollectionName || (exports.UserSubCollectionName = UserSubCollectionName = {}));
var UsageStatsSubCollectionName;
(function (UsageStatsSubCollectionName) {
    UsageStatsSubCollectionName["USER_STATS"] = "userStats";
})(UsageStatsSubCollectionName || (exports.UsageStatsSubCollectionName = UsageStatsSubCollectionName = {}));
exports.PREMIUM_COLLECTIONS = [
    CollectionName.ANALYSES,
    CollectionName.ARTICLES,
    CollectionName.BANNER_NOTIFICATIONS,
    CollectionName.CDC_LETTER,
    CollectionName.FIVE_INFOS,
    CollectionName.GLOSSARY_TERMS,
    CollectionName.LAW_TEXTS,
    CollectionName.SCHEMAS,
    CollectionName.STATISTICS,
    CollectionName.STATISTIC_ENTRIES,
    CollectionName.VOGEL_ACADEMY,
];
exports.PUBLIC_COLLECTIONS = [
    CollectionName.CITATIONS,
    CollectionName.CODE_ARTICLES,
    CollectionName.DECISIONS,
    CollectionName.PUBLICATION_SHEETS,
    CollectionName.TREES,
];
exports.COMMON_COLLECTIONS = __spreadArray(__spreadArray([], __read(exports.PREMIUM_COLLECTIONS), false), __read(exports.PUBLIC_COLLECTIONS), false);
//# sourceMappingURL=collections.js.map